import { ViewChild } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Additive, DialogBase, ObjectTypeInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  styleUrls: ['CreateSparepatsDialog.css'],
  selector: 'CreateSparepartsDialog',
  templateUrl: 'CreateSparepartsDialog.html',
})
export class CreateSparepartsDialog extends DialogBase {

  public viewModel: ObjectTypeInfo = new ObjectTypeInfo();
  public readonly: boolean = true;

  public objectTypes: ObjectTypeInfo[] = [];
  @ViewChild("tblContent") private tblContent: T4DatatableWidget;

  constructor(
    public dialogRef: MatDialogRef<CreateSparepartsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { sparepartToChange: ObjectTypeInfo, readonly: boolean }
  ) {

    super("CreateSparepartsDialog");
    this.readonly = this.data.readonly;


    if (this.data.sparepartToChange) this.viewModel = this.data.sparepartToChange;
    else {
      this.viewModel.VATPercentage = 25;
      this.viewModel.UnlimitedRelations = true;
    }
  }


  public async selectAllRelations(clear: boolean) {
    if (!clear) {
      for (var i of this.objectTypes) {
        this.tblContent.deselectRow(i);
      }
    }
    else {
      for (var i of this.objectTypes) {
        this.tblContent.selectRow(i);
      }
    }
  }

  public async getObjectTypes() {
    this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetTypes", { type: 0 });

    for (var i of this.objectTypes) {
      if (this.viewModel.AdditiveTo && this.viewModel.AdditiveTo.some(x => x.MainObjectId == i.Id))
        this.tblContent.selectRow(i);
    }
  }

  public async ngOnInit() {
    await this.getObjectTypes();
  }

  public async save() {

    var token = this.beginLoad("T4.Settings.SparepartDialog.msgCreating", "Saving spare part", null);

    this.viewModel.AdditiveTo = [];
    for (var type of this.tblContent.selectedRows) {
      var a: Additive = new Additive();
      a.MainObjectId = type.Id;
      this.viewModel.AdditiveTo.push(a);
    }

    var success = await this.Api.post<boolean>("RentalObject/SaveAddon", this.viewModel, { type: 1});
    this.endLoad(token);
    if (success) {
      this.dialogRef.close();
    }
    else {
      alert("Failed, try again!");
    }
  }
}

